export default "__VITE_ASSET__BExmBAL4__"